import { firestoreAction } from 'vuexfire'
import { db } from '@/config/firebase'
import firebase from 'firebase/app'
import { auth } from '@/config/firebase'

const users = {
  namespaced: true,
  state: {
    activeUser: {},
    activeAdmin: {},
    users: []
  },
  mutations: {
    setActiveUser(state, payload) {
      state.activeUser = payload
    },
    setActiveAdmin(state, payload) {
      state.activeAdmin = payload
    },
    setUsers(state, payload) {
      state.users = payload
    }
  },
  actions: {
    setActiveUser: function(context, payload) {
      context.commit('setActiveUser', payload.user)
    },
    setActiveAdmin: function(context, payload) {
      context.commit('setActiveAdmin', payload.admin)
    },
    setUsers: function(context, payload) {
      context.commit('setUsers', payload.users)
    },
    verificateWithEmail: async function() {
      await auth.currentUser.sendEmailVerification()
    },
    signUpWithPassword: async function(context, payload) {
      let ok = true
      try {
        await firebase
          .auth()
          .createUserWithEmailAndPassword(payload.email, payload.password)

        context.dispatch('verificateWithEmail')
      } catch (error) {
        ok = false
      }

      return ok
    },
    signInWithPassword: async function(context, payload) {
      await firebase
        .auth()
        .setPersistence(firebase.auth.Auth.Persistence.SESSION)

      const result = await firebase
        .auth()
        .signInWithEmailAndPassword(payload.email, payload.password)

      return result.user
    },
    signInWithToken: async function(context, payload) {
      await firebase
        .auth()
        .setPersistence(firebase.auth.Auth.Persistence.SESSION)

      const result = await firebase.auth().signInWithCustomToken(payload.token)

      return result.user
    },
    signOut: async function(context) {
      await firebase.auth().signOut()

      context.commit('setActiveUser', {})
    },
    bindRef: firestoreAction(context => {
      return context.bindFirestoreRef('users', db.collection('users'))
    })
  },
  getters: {
    getActiveUser(state) {
      return state.activeUser
    },
    getActiveUserId(state) {
      return state.activeUser.uid
    },
    getActiveAdmin(state) {
      return state.activeAdmin
    },
    getUsers(state) {
      return state.users
    }
  },
  modules: {
    notifs: {
      namespaced: true,
      state: {
        notifs: []
      },
      actions: {
        bindRef: firestoreAction(context => {
          return context.bindFirestoreRef(
            'notifs',
            db
              .collection('users')
              .doc(context.rootGetters['users/getActiveUserId'])
              .collection('notifications')
          )
        })
      },
      getters: {
        getNotifs: state => state.notifs
      }
    },
    receivers: {
      namespaced: true,
      state: {
        receivers: []
      },
      actions: {
        bindRef: firestoreAction(context => {
          return context.bindFirestoreRef(
            'receivers',
            db
              .collection('users')
              .doc(context.rootGetters['users/getActiveUserId'])
              .collection('receivers')
          )
        })
      },
      getters: {
        getReceivers: state => state.receivers
      }
    }
  }
}

export default users
